import { render, staticRenderFns } from "./LeftNavCustomizationPage.vue?vue&type=template&id=0fbace16&scoped=true"
import script from "./LeftNavCustomizationPage.vue?vue&type=script&lang=js"
export * from "./LeftNavCustomizationPage.vue?vue&type=script&lang=js"
import style0 from "./LeftNavCustomizationPage.vue?vue&type=style&index=0&id=0fbace16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbace16",
  null
  
)

export default component.exports